<template>
  <div class="wrapper">
    <MaterialList :project-id="data.projectId" />
  </div>
</template>

<script setup>
import MaterialList from "@/views/PackageEntry/MaterialList.vue";

const props = defineProps({
  data: {
    default: {}
  },
})
</script>

<style scoped lang="scss">
.wrapper {
  width: 950px;
  margin-top: 5px;
  @media (max-width: 991px) {
    width: 100%;
  }
}
</style>
